import { fetchHotel, fetchTaxiVoucher, fetchTaxiCompanies, updatePaxMultiple } from '@/api/service'
const getTaxi = (context) => {
  return fetchHotel().then((response) => {
    context.commit('TAXI_UPDATED', response)
    return context.state.Taxi
  })
}

const getTaxiVoucher = (context) => {
  return fetchTaxiVoucher().then((response) => {
    if (!_.isEmpty(response)) {
      context.commit('TAXI_VOUCHER_UPDATED', response)
    }
  })
}

const getTaxiCompanies = (context) => {
  return fetchTaxiCompanies().then((response) => {
    if (!_.isEmpty(response)) {
      context.commit('TAXI_COMPANIES_UPDATED', response)
    }
  })
}

const updatePhoneNumber = (context, payload) => {
  return updatePaxMultiple(payload).then((response) => {
    return response
  })
}

export default {
  getTaxi,
  getTaxiVoucher,
  getTaxiCompanies,
  updatePhoneNumber
}
